import InvoiceRemark from './InvoiceRemark';

class NomenclatureExclusion extends InvoiceRemark {
    GroupExclusion: boolean;
    Nomenclature1: string;
    ProcedureCode1: string;
    Nomenclature2: string;
    ProcedureCode2: string;
    Information: string;
    info(t: Function): React.ReactElement {
        return this.GroupExclusion
            ? <>{this.Information}</>
            : <>{this.Nomenclature1} ({this.ProcedureCode1}) {t('And')} {this.Nomenclature2} ({this.ProcedureCode2}) - {this.Information}</>;
    }

    constructor(groupExclusions: boolean, nomenclature1: string, procedureCode1: string, nomenclature2: string, procedureCode2: string, information: string) {
        super();
        this.GroupExclusion = groupExclusions;
        this.Nomenclature1 = nomenclature1;
        this.ProcedureCode1 = procedureCode1;
        this.Nomenclature2 = nomenclature2;
        this.ProcedureCode2 = procedureCode2;
        this.Information = information;
    }
}

export default NomenclatureExclusion;
